import { SearchCriteria } from "./searchCriteria";

export class SearchCriteriaGroup {
    searchCriterias: SearchCriteria[];

    orPredicate: boolean;

    constructor(seachCriterias: SearchCriteria[], orPredicate: boolean = false) {
        this.searchCriterias = seachCriterias;
        this.orPredicate = orPredicate;
    }
}